import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchClientSubmissionsStart,
  fetchClientSubmissionsSuccess,
  fetchClientSubmissionsFailure,
  fetchAllJobsSuccess,
  fetchAllJobsFailure,
  fetchAllJobsStart,
  fetchPipelineStart,
  fetchPipelineSuccess,
  fetchPipelineFailure,
  clearPipeline,
  fetchMonsterClassicSuccess,
  fetchMonsterClassicFailure,
  fetchMonsterClassicStart,
  fetchRecentHistorySuccess,
  fetchRecentHistoryFailure,
  fetchSavedHistorySuccess,
  fetchSavedHistoryFailure,
  fetchRecentHistoryStart,
  fetchSavedHistoryStart,
  fetchConfirmedOrStartSuccess,
  fetchConfirmedOrStartFailure,
  fetchConfirmedOrStartStart,
  fetchFollowupInterviewsSuccess,
  fetchFollowupInterviewsFailure,
  fetchFollowupInterviewsStart,
  fetchResumeMiningStart,
  fetchResumeMiningSuccess,
  fetchResumeMiningFailure,
  fetchResumeDataStart,
  resumeDataSuccess,
  resumeDataFailure,
  fetchCompanyLeadsFailure,
  fetchCompanyLeadsSuccess,
  fetchCompanyLeadsStart,
  fetchJobLeadsSuccess,
  fetchJobLeadsFailure,
  fetchJobLeadsStart,

} from "./bdmjobsSlice";
import { fetchAllJobsApi, fetchClientSubmissionsApi, fetchConfirmedOrStartApi, fetchJobBoardHistoryApi, MonsterClassicSearch, fetchResumeMining, getLeadCompany, getLeadJobs,  } from "./bdmjobsApi";
import { showToast } from "../../../components";

function* fetchClientSubmissionsWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchClientSubmissionsApi, params);
    if (response?.data) {
      const submissionsData = response?.data?.data || [];
      yield put(
        fetchClientSubmissionsSuccess({
          data: submissionsData,
          total: response.data.total || submissionsData.length || 0,
        }),
      );
      // optional success callback
      if (onSuccess) onSuccess(submissionsData);
    } else {
      yield put(
        fetchClientSubmissionsFailure("Failed to fetch client submissions"),
      );
      // showToast("Failed to fetch client submissions", "error", 2000);
    }
  } catch (error) {
    yield put(fetchClientSubmissionsFailure(error.message));
    showToast(
      error.message || "Failed to fetch client submissions",
      "error",
      2000,
    );
  }
}

function* fetchAllJobsWorker(action) {
  try {
    const params = action.payload || {};

    const response = yield call(fetchAllJobsApi, params);
    const jobsData = response?.data?.data || [];
    yield put(fetchAllJobsSuccess({ data: jobsData }));
    // if (response?.data) {

    // } else {
    //   yield put(fetchAllJobsFailure("Failed to fetch jobs"));
    //   // showToast("Failed to fetch jobs", "error", 2000);
    //   console.log(error);
    // }
  } catch (error) {
    yield put(fetchAllJobsFailure(error.message));
  }
}
function* fetchPipelineWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchClientSubmissionsApi, params);
    const pipelineData = response?.data?.data || [];
    yield put(fetchPipelineSuccess({ data: pipelineData }));

    // if (response?.data) {

    //   if (onSuccess) onSuccess(pipelineData);
    // } else {
    //   yield put(fetchPipelineFailure("Failed to fetch pipeline"));
    // }
  } catch (error) {
    yield put(fetchPipelineFailure(error.message));
  }
}

function* fetchMonsterClassicWorker(params) {
  // console.log(params.payload, "params")
  try {
    // console.log("monster classic params", params);
    const response = yield call(MonsterClassicSearch, params.payload);

    if (response) {
      const result = yield call(
        parseXMLMonsterClassicSearch,
        response?.data?.data?.response?.monsterResponse,
      );

      // console.log("monster search", result);
      const existingCandidates =
        response?.data?.data?.response?.existingCandidates;
      // console.log("matchingCandidates", matchingCandidates);
      const data = {
        ...result,
        existingCandidates,
      };
      yield put(fetchMonsterClassicSuccess(data));

      if (result?.total === 0) {
        showToast("No search results found.", "error");
      }

      if (
        result?.tableResponse.length > 0 &&
        typeof params.payload.onSuccess === "function" &&
        params?.payload?.onSuccess()
      ) {
        yield call(params.payload.onSuccess);
      }
    }
  } catch (error) {
    yield put(fetchMonsterClassicFailure([]));
    console.error("Monster  Search error:", error);
  }
}

function* fetchJobBoardHistoryWorker(action) {
  try {
    const { board, subBoard, isRecent, params } = action.payload;
    const response = yield call(fetchJobBoardHistoryApi, params);
    const data = response?.data?.data || [];

    if (isRecent) {
      yield put(fetchRecentHistorySuccess({ board, subBoard, data }));
    } else {
      yield put(fetchSavedHistorySuccess({ board, subBoard, data }));
    }
  } catch (error) {
    const { board, subBoard, isRecent } = action.payload;
    if (isRecent) {
      yield put(
        fetchRecentHistoryFailure({ board, subBoard, error: error.message }),
      );
    } else {
      yield put(
        fetchSavedHistoryFailure({ board, subBoard, error: error.message }),
      );
    }
  }
}

function* fetchConfirmedOrStartWorker(action) {
  try {
    const response = yield call(fetchConfirmedOrStartApi, action.payload);
    const data = response?.data?.data || [];
    const total = response?.data?.total || data.length || 0;

    yield put(fetchConfirmedOrStartSuccess({ data, total }));
  } catch (error) {
    yield put(fetchConfirmedOrStartFailure(error.message));
  }
}

function* fetchFollowupInterviewsSaga(action) {
  try {
    const response = yield call(fetchConfirmedOrStartApi, action.payload);
    const data = response?.data?.data || [];
    const total = response?.data?.total || data.length || 0;
    yield put(fetchFollowupInterviewsSuccess({ data, total }));
  } catch (error) {
    yield put(fetchFollowupInterviewsFailure(error.message));
  }
}

function* fetchResumeMiningWorker(action) {
  try {
    const { onSuccess, ...params } = action.payload;
    const response = yield call(fetchResumeMining, params);
    if (response?.data) {
      const submissionsData = response?.data?.data || [];
      yield put(
        fetchResumeMiningSuccess({
          data: submissionsData,
        }),
      );
      // optional success callback
      if (onSuccess) onSuccess(submissionsData);
    } else {
      yield put(fetchResumeMiningFailure("Failed to fetch Resume Mining Data"));
      console.warn("Failed to fetch Resume Mining Data");
    }
  } catch (error) {
    yield put(fetchResumeMiningFailure(error.message));
    showToast(
      error.message || "Failed to fetch Resume Mining Data",
      "error",
      2000,
    );
  }
}

function* fetchResumeDataWorker(action) {
  try {
    // console.log(action.payload, "yfkjhvkuygfjv,")
    const data = action.payload || {};
    yield put(resumeDataSuccess({ data: data }));
  } catch (error) {
    yield put(resumeDataFailure(error.message || "localstorage error"));
  }
}

function* fetchCompanyLeadsWorker(action) {
  try {
    const params = action.payload;

    const response = yield call(getLeadCompany, params);
    if (response?.data?.data) {
      const list = response.data.data || [];

      yield put(
        fetchCompanyLeadsSuccess({
          data: list,
        })
      );
    } else {
      yield put(fetchCompanyLeadsFailure("Failed to fetch company leads"));
    }
  } catch (error) {
    yield put(fetchCompanyLeadsFailure(error.message));
    console.log(error?.response?.data?.message || "Failed to fetch company leads", "error");
  }
}

export function* fetchJobLeadsWorker(action) {
  try {
    const res = yield call(getLeadJobs, action.payload);
     yield put(
        fetchJobLeadsSuccess({
          data: res?.data?.data || [],
          total: res?.data?.total || 0,
        })
      );
  } catch (error) {
    yield put(
      fetchJobLeadsFailure(
        error?.response?.data?.message || "API error"
      )
    );
  }
}


export function* watchFetchClientSubmissions() {
  yield takeLatest(
    fetchClientSubmissionsStart.type,
    fetchClientSubmissionsWorker,
  );
  yield takeLatest(fetchAllJobsStart.type, fetchAllJobsWorker);
  yield takeLatest(fetchPipelineStart.type, fetchPipelineWorker);
  yield takeLatest(fetchMonsterClassicStart.type, fetchMonsterClassicWorker);
  yield takeLatest(fetchRecentHistoryStart.type, fetchJobBoardHistoryWorker);
  yield takeLatest(fetchSavedHistoryStart.type, fetchJobBoardHistoryWorker);
  yield takeLatest(
    fetchConfirmedOrStartStart.type,
    fetchConfirmedOrStartWorker,
  );
  yield takeLatest(
    fetchFollowupInterviewsStart.type,
    fetchFollowupInterviewsSaga,
  );
  yield takeLatest(fetchResumeMiningStart.type, fetchResumeMiningWorker);
  yield takeLatest(fetchResumeDataStart.type, fetchResumeDataWorker);
  yield takeLatest(fetchCompanyLeadsStart.type,fetchCompanyLeadsWorker);
  yield takeLatest(fetchJobLeadsStart.type, fetchJobLeadsWorker);

}

async function parseXMLMonsterClassicSearch(xmlString) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, "application/xml");

  // Validate XML
  const error = xmlDoc.querySelector("parsererror");
  if (error) throw new Error("Invalid XML: " + error.textContent);

  const resumes = Array.from(xmlDoc.getElementsByTagName("Resume"));
  const resumesElement = xmlDoc.querySelector("Resumes");
  const total = parseInt(resumesElement?.getAttribute("Found")) || 0;

  const getText = (parent, selector, defaultValue = "N/A") => {
    const el = parent.querySelector(selector);
    return el?.textContent?.trim() || defaultValue;
  };

  // Helper to get multiple values (like job types)
  const getAllText = (parent, selector) => {
    return (
      Array.from(parent.querySelectorAll(selector))
        .map((el) => el.textContent.trim())
        .filter(Boolean)
        .join(", ") || "N/A"
    );
  };

  // Helper: Calculate experience duration from <DateFrom> and <DateTo>
  const calculateExperience = (resume) => {
    const experiences = Array.from(
      resume.querySelectorAll("Experiences > Experience"),
    );
    if (!experiences.length) return "No experience";

    let totalMonths = 0;

    experiences.forEach((exp) => {
      const fromYear =
        parseInt(exp.querySelector("DateFrom")?.getAttribute("Year")) || null;
      const fromMonth =
        parseInt(exp.querySelector("DateFrom")?.getAttribute("Month")) || 1;
      const toYear =
        parseInt(exp.querySelector("DateTo")?.getAttribute("Year")) ||
        new Date().getFullYear();
      const toMonth =
        parseInt(exp.querySelector("DateTo")?.getAttribute("Month")) ||
        new Date().getMonth() + 1;

      if (fromYear && toYear) {
        const months = (toYear - fromYear) * 12 + (toMonth - fromMonth);
        totalMonths += months > 0 ? months : 0;
      }
    });

    if (totalMonths <= 0) return "No experience";

    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;

    if (years === 0) return `${months} month${months !== 1 ? "s" : ""}`;
    if (months === 0) return `${years} year${years !== 1 ? "s" : ""}`;
    return `${years} year${years !== 1 ? "s" : ""} ${months} month${months !== 1 ? "s" : ""}`;
  };

  const getHighestEducation = (resume) => {
    const levels = Array.from(
      resume.querySelectorAll("Educations > Education > Level"),
    )
      .map((el) => el.textContent.trim())
      .filter(Boolean);
    if (!levels.length) return "N/A";
    return levels[0];
  };

  // Compact view
  const tableResponse = resumes.map((resume, index) => {
    const firstName = getText(resume, "PersonalData > Name > First");
    const lastName = getText(resume, "PersonalData > Name > Last");
    const location = getText(resume, "PersonalData > Address > Location");
    const jobTitle = getText(resume, "Target > JobTitle");
    const relocation = getText(resume, "Target > Relocation");
    const jobType = getAllText(resume, "Target > JobTypes > JobType");
    const lastUpdate = getText(resume, "DateModified");
    const highestEducation = getHighestEducation(resume);
    const experience = calculateExperience(resume);
    const source = getText(resume, "Boards > Board");
    const md5Email = getText(resume, "PersonalData > MD5-EmailAddress");

    return {
      index,
      applicantId: resume.getAttribute("SID") || "N/A",
      resumeId: resume.getAttribute("SID") || "N/A",
      name: `${firstName} ${lastName}`.trim(),
      md5Email,
      jobTitle,
      experience,
      highestEducation,
      location,
      relocation,
      jobType,
      lastUpdate,
      source,
    };
  });

  // Detailed view
  const fullResponse = resumes.map((resume, index) => {
    const firstName = getText(resume, "PersonalData > Name > First");
    const lastName = getText(resume, "PersonalData > Name > Last");
    const location = getText(resume, "PersonalData > Address > Location");
    const country = getText(resume, "PersonalData > Address > Country");
    const state = getText(resume, "PersonalData > Address > State");
    const city = getText(resume, "PersonalData > Address > City");
    const postalCode = getText(resume, "PersonalData > Address > PostalCode");
    const md5Email = getText(resume, "PersonalData > MD5-EmailAddress");
    const jobTitle = getText(resume, "Target > JobTitle");
    const relocation = getText(resume, "Target > Relocation");
    const jobType = getAllText(resume, "Target > JobTypes > JobType");
    const lastUpdate = getText(resume, "DateModified");
    const dateCreated = getText(resume, "DateCreated");
    const experienceCompany = getText(
      resume,
      "Experiences > Experience > Company > Name",
    );
    const experienceJobTitle = getText(
      resume,
      "Experiences > Experience > Job > Title",
    );
    const experienceDescription = getText(
      resume,
      "Experiences > Experience > Job > Description",
    );
    const workAuthCountry = getText(resume, "WorkAuths > WorkAuth > Country");
    const workAuthType = getText(resume, "WorkAuths > WorkAuth > AuthType");
    const experience = calculateExperience(resume);
    const source = getText(resume, "Boards > Board");

    return {
      index,
      applicantId: resume.getAttribute("SID") || "N/A",
      resumeId: resume.getAttribute("SID") || "N/A",
      firstName,
      lastName,
      name: `${firstName} ${lastName}`.trim(),
      md5Email,
      location,
      country,
      state,
      city,
      postalCode,
      jobTitle,
      relocation,
      jobType,
      lastUpdate,
      dateCreated,
      experienceCompany,
      experienceJobTitle,
      experienceDescription,
      totalExperience: calculateExperience(resume),
      experience,
      highestEducation: getHighestEducation(resume),
      workAuthCountry,
      workAuthType,
      source,
    };
  });

  return { total, tableResponse, fullResponse };
}
